export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/bags.35c634d.svg";